<ng-container *ngIf="loading">
    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '150px'
      }">
    </ngx-skeleton-loader>

    <app-spacer [bottom]="24"></app-spacer>

    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '300px'
      }">
    </ngx-skeleton-loader>
</ng-container>

<ng-container *ngIf="!loading">
    <div class="dash-card no-padding">
        <div
            class=" dash-card-header d-flex align-items-start justify-content-between">
            <h2>Grupos de permissões</h2>
        </div>

        <div class="dash-card-body padding-container mb-5">
            <div class="col-12" style="padding: 0 30px 20px;">
                <div class="row">
                    <div class="col-lg-3">
                        <p class="title">
                            Nome do grupo de permissões</p>
                        <p class="label">
                            {{data.group}}
                        </p>
                    </div>

                    <div class="col-lg-2">
                        <p class="title">Criado por</p>
                        <p class="label">
                            {{data.created_by === '' ? 'Sistema' :
                            data.created_by}}
                        </p>
                    </div>

                    <div class="col-lg-2">
                        <p class="title">Última atualização</p>
                        <p class="label">
                            {{data.updated_at}}
                        </p>
                    </div>

                    <div
                        class="col-lg-5 d-flex justify-content-end align-items-start">
                        <app-button (onClick)="togglePermissionStatus()"
                            [outline]="data.status === 'Ativo'"
                            [danger]="data.status === 'Ativo'"
                            class="add-button"
                            *ngIf="permissionObj.canInactive">
                            {{data.status === 'Ativo' ? 'Inativar' :
                            'Ativar'}}
                            grupo de permissões
                        </app-button>
                        <app-spacer [right]="8"></app-spacer>

                        <app-button (onClick)="addPermission()"
                            class="add-button" *ngIf="permissionObj.canChange">
                            Editar grupo de permissões
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dash-card no-padding" *ngIf="permissionsArray.length > 0">
        <div
            class=" dash-card-header d-flex align-items-start justify-content-between">
            <h2>Permissões</h2>
        </div>


        <div class="ml-5 mr-5 pb-3">
            <app-permission-tree [permissions]="permissionTree" [level]="0"
                [baseData]="permissionsBaseData" [readOnly]="true"
                [selectedPermissions]="permissionsAvaliablePicked"
                (permissionChange)="handlePermissionSelection($event)">
            </app-permission-tree>
        </div>

        <!-- <div class="permission-list">
            <ul class="permission-group">
                <ng-container *ngFor="let group of permissionsArray;">
                    <li class="permission-group-title">
                        {{group.type}}
                    </li>

                    <li *ngFor="let item of group.permissions;">
                        {{item.description}}
                    </li>
                </ng-container>
            </ul>
        </div> -->
    </div>
</ng-container>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>

<!-- <div class="col-12 ml-auto mr-auto mb-4">
    <div class="dash-card-pagination">
        <app-pagination [data]="[]" [show]="!loading" [dashPagination]="true">
        </app-pagination>
    </div>
</div> -->